const maps = [
  require("../maps/burg.json"),
  require("../maps/freight.json"),
  require("../maps/kanji.json"),
  require("../maps/littletown.json"),
  require("../maps/lostworld.json"),
  require("../maps/sandstorm.json"),
  require("../maps/shipyard.json"),
  require("../maps/subzero.json"),
  require("../maps/undergrowth.json"),
];

if (localStorage.mapIndex === undefined) localStorage.mapIndex = 0;

localStorage.custMap = JSON.stringify(maps[+localStorage.mapIndex]);

// Expose the map list + switcher so the dev console (game.js) can drive
// map changes. This bundle (hook.js) owns the map JSONs; game.js reads
// them only via localStorage, so we expose a small window API here.
window.__krunkerMaps = maps.map((m, i) => (m && m.name) || ("map " + i));
window.__krunkerMapCount = maps.length;
window.__krunkerMapData = maps;
window.__krunkerSetMapIndex = function (i) {
  var n = parseInt(i, 10);
  if (!(n >= 0 && n < maps.length)) return false;
  localStorage.mapIndex = n;
  location.reload();
  return true;
};

history.pushState = history.replaceState = () => {};
